import { INTERVIEW_RATING_DECISION } from '@/constant/interview'

export const QUESTIONNAIRE_QUESTION_TYPE = {
  TEXT: {
    i18nKey: 'admin.questionnaire.questionType.text',
    value: 'TEXT'
  },
  DATE: {
    i18nKey: 'admin.questionnaire.questionType.date',
    value: 'DATE'
  },
  SINGLE: {
    i18nKey: 'admin.questionnaire.questionType.single',
    value: 'SINGLE'
  },
  MULTIPLE: {
    i18nKey: 'admin.questionnaire.questionType.multiple',
    value: 'MULTIPLE'
  },
  ATTACHMENT: {
    i18nKey: 'admin.questionnaire.questionType.attachment',
    value: 'ATTACHMENT'
  },
  LINK: {
    i18nKey: 'admin.questionnaire.questionType.link',
    value: 'LINK'
  },
  LANGUAGE: {
    i18nKey: 'admin.questionnaire.questionType.language',
    value: 'LANGUAGE'
  },
  NATIONALITY: {
    i18nKey: 'admin.questionnaire.questionType.nationality',
    value: 'NATIONALITY'
  },
  COUNTRY: {
    i18nKey: 'admin.questionnaire.questionType.country',
    value: 'COUNTRY'
  },
  PROVINCE: {
    i18nKey: 'admin.questionnaire.questionType.province',
    value: 'PROVINCE'
  },
  CITY: {
    i18nKey: 'admin.questionnaire.questionType.city',
    value: 'CITY'
  },
  LOCATION: {
    // this is a virtual type, worked for scoped type
    i18nKey: 'admin.questionnaire.questionType.location',
    value: 'LOCATION'
  },
  NPS: {
    i18nKey: 'admin.questionnaire.questionType.nps',
    value: 'NPS'
  },
  STARS: {
    i18nKey: 'admin.questionnaire.questionType.stars',
    value: 'STARS'
  },
  REPEAT_GROUP: {
    i18nKey: 'admin.questionnaire.questionType.repeatGroup',
    value: 'REPEAT_GROUP'
  },
  DATE_RANGE: {
    i18nKey: 'admin.questionnaire.questionType.dateRange',
    value: 'DATE_RANGE'
  }
}

export const QUESTIONNAIRE_SIGNATURE_TYPE = 'SIGN'

export const JOB_APPLICATION_QUESTION_TYPE = {
  ...QUESTIONNAIRE_QUESTION_TYPE,
  SIGN: {
    i18nKey: 'admin.company.jobApplication.questionType.signature',
    value: QUESTIONNAIRE_SIGNATURE_TYPE
  }
}

export const QUESTION_SCOPED_TYPE = ['COUNTRY', 'PROVINCE', 'CITY']

export const QUESTION_UNSUPPORT_TYPE = ['LANGUAGE', 'NATIONALITY', 'COUNTRY', 'PROVINCE', 'CITY', 'LOCATION']

export const QUESTION_STRUCTURED_TYPE = ['REPEAT_GROUP']

export const ONLY_JOB_APPLICATION_QUESTION_TYPE = ['REPEAT_GROUP', 'DATE_RANGE', QUESTIONNAIRE_SIGNATURE_TYPE]

export const QUESTION_PREFILL_SOURCE = {
  NONE: {
    i18nKey: 'admin.questionnaire.prefillSource.none',
    value: null
  },
  CANDIDATE_NAME: {
    i18nKey: 'admin.questionnaire.prefillSource.candidateName',
    value: 'candidate_name'
  },
  CANDIDATE_MOBILE: {
    i18nKey: 'admin.questionnaire.prefillSource.candidateMobile',
    value: 'candidate_mobile'
  },
  CANDIDATE_EMAIL: {
    i18nKey: 'admin.questionnaire.prefillSource.candidateEmail',
    value: 'candidate_email'
  },
  JOB_TITLE: {
    i18nKey: 'admin.questionnaire.prefillSource.jobTitle',
    value: 'job_title'
  },
  RESUME_EDUCATION: {
    i18nKey: 'admin.questionnaire.prefillSource.resumeEducation',
    value: 'resume_education'
  },
  RESUME_WORK: {
    i18nKey: 'admin.questionnaire.prefillSource.resumeWork',
    value: 'resume_work'
  }
}

export const SATISFACTION_SURVEY_SCOPE = 'SATISFACTION'

export const POST_APPLICANT_SCOPE = 'POST_APPLICANT'

export const JOB_APPLICATION_SCOPE = 'JOB_APPLICATION'

export const QUESTIONNAIRE_TYPE_LIST = [POST_APPLICANT_SCOPE, SATISFACTION_SURVEY_SCOPE, JOB_APPLICATION_SCOPE]

export const WECHAT_SPREAD_QUESTIONNAIRE_LIST = [SATISFACTION_SURVEY_SCOPE, POST_APPLICANT_SCOPE, JOB_APPLICATION_SCOPE]

export const HM_QUESTIONNAIRE_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled'
}

export const HM_QUESTION_TYPE = {
  RATING: 'rating',
  TEXT: 'text',
  SINGLE: 'single_select',
  MULTIPLE: 'multi_select',
  DATE: 'date'
}

export const HM_OVERALL_RATING_TYPE = {
  NEW: 'new',
  LEGACY: 'legacy'
}

export const HM_RECOMMENDATION_MAP = {
  not_yet_rate: 'NOT_YET_RATE',
  recommended: 'RECOMMENDED',
  not_recommended: 'NOT_RECOMMENDED',
  no_recommendation: 'NO_RECOMMENDATION',
  todo: 'RATE_PENDING',
  conflict: 'SPLIT_DECISION'
}

export const HM_RECOMMENDATION_DECISION_MAP = {
  [HM_RECOMMENDATION_MAP.not_yet_rate]: INTERVIEW_RATING_DECISION.NOT_RATE_YET,
  [HM_RECOMMENDATION_MAP.recommended]: INTERVIEW_RATING_DECISION.RECOMMENDED,
  [HM_RECOMMENDATION_MAP.not_recommended]: INTERVIEW_RATING_DECISION.NOT_RECOMMENDED,
  [HM_RECOMMENDATION_MAP.no_recommendation]: INTERVIEW_RATING_DECISION.NO_RECOMMENDATION,
  [HM_RECOMMENDATION_MAP.todo]: INTERVIEW_RATING_DECISION.PENDING,
  [HM_RECOMMENDATION_MAP.conflict]: INTERVIEW_RATING_DECISION.CONFLICT
}

export const HM_RECOMMENDATION_DISPLAY_MAP = {
  [INTERVIEW_RATING_DECISION.RECOMMENDED]: {
    shortLabel: 'Y',
    i18nKey: HM_RECOMMENDATION_MAP.recommended,
    color: '#51BF82'
  },
  [INTERVIEW_RATING_DECISION.NOT_RECOMMENDED]: {
    shortLabel: 'N',
    i18nKey: HM_RECOMMENDATION_MAP.not_recommended,
    color: '#E27676'
  },
  [INTERVIEW_RATING_DECISION.PENDING]: {
    shortLabel: 'P',
    i18nKey: HM_RECOMMENDATION_MAP.todo,
    color: '#F4A958'
  },
  [INTERVIEW_RATING_DECISION.NO_RECOMMENDATION]: {
    shortLabel: 'P',
    i18nKey: HM_RECOMMENDATION_MAP.no_recommendation,
    color: '#F4A958'
  },
  [INTERVIEW_RATING_DECISION.CONFLICT]: {
    shortLabel: 'Y/N',
    i18nKey: HM_RECOMMENDATION_MAP.conflict,
    color: '#F4A958'
  },
  [INTERVIEW_RATING_DECISION.NOT_RATE_YET]: {
    shortLabel: '···',
    i18nKey: HM_RECOMMENDATION_MAP.not_yet_rate
  }
}

export const HM_QUESTION_STATUS = HM_QUESTIONNAIRE_STATUS

export const HM_FORM_STATUS = {
  OPEN: true,
  CLOSED: false
}

export const HM_SCALE_MIN_SCORE = 0
